import { takeLatest, put, all, call, CallEffect, PutEffect } from 'redux-saga/effects';
import EmployeeListActionTypes from './employeelist.types';
import {
	getAllEmployeeListData,
	fetchEmployeeDetailsBasedOnID,
	updateEmployeeDetails,
} from './employeelist.service';
import {
	// employeelistSuccess,
	// employeelistFailure,
	getAllEmployeeListFailure,
	getAllEmployeeListSuccess,
	getEmployeeByIDSuccess,
	getEmployeeByIDFailure,
	updateEmployeeSuccess,
	updateEmployeeFailure,
} from './employeelist.action';
import { isEditDetailsStart } from '../../redux/general/general.action';
import { encryptData } from '../_common/enode-decode';
import AlertManager from '../../utils/alertManager';

// export function* fetchEmployeeListData(data: any): Generator<CallEffect | PutEffect, void, any> {
// 	try {
// 		console.log(`OrgID${data.payload}`);
// 		const payloadToPass = {
// 			organisationID: data.payload,
// 		};
// 		const response = yield call(getEmployeeListData, payloadToPass);
// 		if (response.data.statusCode === '401') {
// 			// Show token validation alert
// 			AlertManager.showTokenValidationAlert();
// 			return;
// 		} else {
// 			if (response.data.status === 'success') {
// 				yield put(employeelistSuccess(response.data));
// 			} else {
// 				yield put(employeelistFailure(response.data));
// 			}
// 		}
// 	} catch (error) {
// 		yield put(employeelistFailure(error));
// 	}
// }

export function* fetchAllEmployeeListData(data: any) {
	try {
		const payloadToPass = {
			organisationID: data.payload,
		};
		const encryptedData = encryptData(
			payloadToPass,
			EmployeeListActionTypes.GET_ALL_EMPLOYEE_LIST_KEY,
		);
		// @ts-ignore
		const response = yield call(getAllEmployeeListData, encryptedData);
		if (response.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (response.data.status === 'success') {
				yield put(
					getAllEmployeeListSuccess({
						status: 'success',
						response: response.data.response, // Pass the encrypted response
					}),
				);
			} else {
				yield put(getAllEmployeeListFailure(response.data));
			}
		}
	} catch (error) {
		console.error('Error fetching employee list:', error);
		yield put(getAllEmployeeListFailure(error));
	}
}

export function* fetchEmployeeDetailsBasedOnIDSaga(
	data: any,
): Generator<CallEffect | PutEffect, void, any> {
	try {
		const payLoadData: any = {
			databaseName: data.payload.databaseName,
		};
		
		// Use employeeID if provided, otherwise fall back to empID
		if (data.payload.employeeID !== undefined && data.payload.employeeID !== null) {
			payLoadData.employeeID = data.payload.employeeID;
		} else if (data.payload.empID !== undefined && data.payload.empID !== null) {
			// Convert empID to employeeID if needed - but API now expects employeeID
			// For now, we'll try to get employeeID from empID or use empID as fallback
			payLoadData.employeeID = data.payload.empID; // API will handle conversion if needed
		}
		
		const Key = 'fetchEmployeeDetailsBasedOnIDKey';
		const encryptedData = encryptData(payLoadData, Key);
		console.log('DEBUG - Saga received data:', encryptedData);
		console.log('DEBUG - Payload data:', payLoadData);
		const response = yield call(fetchEmployeeDetailsBasedOnID as any, encryptedData);
		// if (response.data.status === '401') {
		// 	// Show token validation alert
		// 	AlertManager.showTokenValidationAlert();
		// 	return;
		// } else {
		if (response.data.status === 'success') {
			console.log(
				'DEBUG - Employee data before setting form:',
				JSON.stringify(response.data.data, null, 2),
			);
			yield put(getEmployeeByIDSuccess(response.data));
			yield put(isEditDetailsStart(true));
		} else {
			console.error('DEBUG - API returned error:', response.data);
			yield put(getEmployeeByIDFailure(response.data));
		}
		// }
	} catch (error) {
		console.error('DEBUG - Saga error:', error);
		yield put(getEmployeeByIDFailure(error));
	}
}

export function* updateEmployeeDetailsSaga(
	data: any,
): Generator<CallEffect | PutEffect, void, any> {
	try {
		const Key = 'updateEmployeeDetailsKey';
		const encryptedData = encryptData(data.payload, Key);
		const response = yield call(updateEmployeeDetails, encryptedData);
		if (response.data.status === 'success') {
			yield put(updateEmployeeSuccess(response.data));
		} else {
			yield put(updateEmployeeFailure(response.data));
		}
	} catch (error) {
		console.error('Saga error:', error); // Debug log
		yield put(updateEmployeeFailure(error));
	}
}

export function* updateEmployeeSaga(data: any): Generator<CallEffect | PutEffect, void, any> {
	try {
		const Key = 'updateEmployeeDetailsKey';
		const encryptedData = encryptData(data.payload, Key);
		const response = yield call(updateEmployeeDetails, encryptedData);
		if (response.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (response.data.status === 'success') {
				yield put(updateEmployeeSuccess(response.data));
				// Refresh the employee list after successful update
				//yield put(getAllEmployeeListStart());
				// Don't close the form here - let the component handle it after showing success message
			} else {
				console.error('Update failed:', response.data);
				yield put(updateEmployeeFailure(response.data));
			}
		}
	} catch (error) {
		console.error('Update Saga error:', error);
		yield put(updateEmployeeFailure(error));
	}
}

// export function* onEmployeeListSagaStart() {
// 	yield takeLatest(EmployeeListActionTypes.EMPLOYEELIST_START, fetchEmployeeListData);
// }

export function* onAllEmployeeListSagaStart() {
	yield takeLatest(EmployeeListActionTypes.GET_ALL_EMPLOYEE_LIST_START, fetchAllEmployeeListData);
}

export function* onEmployeeByIDSagaStart() {
	yield takeLatest(
		EmployeeListActionTypes.GET_EMPLOYEE_BY_ID_START,
		fetchEmployeeDetailsBasedOnIDSaga,
	);
}

export function* onUpdateEmployeeSagaStart() {
	yield takeLatest(EmployeeListActionTypes.UPDATE_EMPLOYEE_START, updateEmployeeSaga);
}

export function* employeelistSaga() {
	yield all([
		// call(onEmployeeListSagaStart),
		call(onAllEmployeeListSagaStart),
		call(onEmployeeByIDSagaStart),
		call(onUpdateEmployeeSagaStart),
	]);
}
